import {utilArray} from '@gongxigames/framework/lib/util/utilArray';
import {
    ComponentModuleViewConfig,
    IView
} from '@gongxigames/framework/core/types';

export type ViewInitData = [ComponentModuleViewConfig, IView];
export type ViewData = {
    instance: IView;
    config: ComponentModuleViewConfig;
};

export function viewsComponentsSort(views: ViewData[]): ViewData[] {
    const viewInitData = views.map<ViewInitData>(({config, instance}) => [config, instance]);

    sortViewByDependencies(viewInitData);

    return viewInitData.map(([config, instance]) => ({instance, config}));
}

function sortViewByDependencies(views: ViewInitData[]): void {
    // eslint-disable-next-line no-constant-condition
    while (true) {
        let modified = false;

        for (let i = 0; i < views.length; i++) {
            const item = views[i];
            const [, view] = item;
            const dependencies = view.getViewDependencies();
            const isDependenciesLater = !!utilArray.findBy(views, ([iConf]) => {
                return dependencies.includes(iConf.NAME);
            }, i + 1);

            if (isDependenciesLater) {
                modified = true;
                utilArray.remove(views, item);
                views.push(item);

                i--;
            }
        }

        if (!modified) {
            return;
        }
    }
}
